import { NumberInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { RichTextEditor } from "@dzambalaorg/mui-inputs-draft";
import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { TemplateAssetInput } from "@dzambalaorg/mui-inputs-asset";
import { FormGrid } from "@dzambalaorg/ui-kit";
import { DialogMode } from "@framework/shared";

export interface IAchievementLevelDialogFormProps {
  mode: DialogMode;
}

export const AchievementLevelDialogForm = (props: IAchievementLevelDialogFormProps) => {
  const { mode } = props;
  return (
    <FormGrid columns={[2, 2, 1, 1]}>
      <TextInput name="title" />
      <EntityInput name="achievementRuleId" controller="achievements/rules" autoSelect readOnly={mode === "edit"} />
      <NumberInput name="achievementLevel" />
      <NumberInput name="amount" />
      <TemplateAssetInput autoSelect multiple prefix="reward" />
      <RichTextEditor name="description" />
    </FormGrid>
  );
};
